type ValidationRule = {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: RegExp;
  validator?: (value: any) => boolean;
  message?: string;
};

export const providerValidationSchema: Record<string, ValidationRule> = {
  provider_name: {
    required: true,
    minLength: 2,
    maxLength: 100,
  },
  provider_link: {
    required: true,
    pattern: /^(https?:\/\/.+|[^\/]+\..+)/i,
    validator: (value: string) => {
      const trimmed = value.trim();
      return /^(https?:\/\/)?[^\/]+\.[^\/]+/.test(trimmed);
    }
  },
  provider_description: {
    required: true,
    minLength: 10,
    maxLength: 1000,
  },
  provider_types: {
    required: true,
    validator: (value: string[]) => value.length > 0,
    message: "Please select at least one"
  }
}; 